module.exports = __webpack_public_path__ + "img/transport_CarBooking.7b5943b.png";